/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Table_Header_StatusInputs */



/**
* | output |
* | --- |
* | "Status" |
*
* @param {Api_Keys_Table_Header_StatusInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_keys_table_header_status = /** @type {((inputs?: Api_Keys_Table_Header_StatusInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Table_Header_StatusInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Status")
	return /** @type {LocalizedString} */ ("Status")
});